// utils/exportExcel.js
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Export an array of plain objects to an .xlsx file.
 * @param {{data: Array<Object>, fileName?: string, sheetName?: string, columnWidths?: number[]}} opts
 */
export function ExcelReport({ data = [], fileName = "report.xlsx", sheetName = "Sheet1", columnWidths }) {
  if (!Array.isArray(data) || data.length === 0) return;

  // 1) Convert JSON array to worksheet
  const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });

  // 2) Optionally set column widths (wch = characters)
  if (Array.isArray(columnWidths) && columnWidths.length > 0) {
    // If widths are in pixels, you can convert. Here we assume w is approx pixels, convert to chars:
    ws["!cols"] = columnWidths.map((w) => {
      const fallback = 15;
      const wpx = typeof w === "number" ? w : fallback;
      const wch = Math.max(8, Math.round(wpx / 7)); // rough conversion px->chars
      return { wch };
    });
  }

  // 3) Append sheet to workbook
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // 4) Write workbook to binary and trigger download (using file-saver)
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  try {
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
  } catch (err) {
    // fallback
    XLSX.writeFile(wb, fileName);
  }
}
